export const indexUserCsvPath: string = "/users/csv";
export const downloadUserCsvPath: string = "/users/csv/download";
